import { get } from 'config/api/config';

import { ApplicantJourneySession } from 'utils/applicantJourneyTimeline';

const JOURNEY_ENDPOINT = '/lead-profile/journey';

export interface GetApplicantJourneyParams {
  responseId: string;
  sessionId?: string;
  limit?: number;
}

export async function getApplicantJourney(
  params: GetApplicantJourneyParams,
): Promise<ApplicantJourneySession[]> {
  const response = await get(JOURNEY_ENDPOINT, { params });
  return response.data;
}
